module.exports = __webpack_public_path__ + "static/media/LifeLine3.8da6d221.png";